export default "__VITE_ASSET__BIfVegLK__"